import { useEffect, useRef } from "react";
import { createControlSocket, resetSubscriptions } from "./socket";

export function useSrdkoreaSocket(userId, bsdIds, onMessage, onAlarm) {
  const clientRef = useRef(null);

  const userIdRef = useRef(userId);
  const bsdIdsRef = useRef(bsdIds);
  const onMessageRef = useRef(onMessage);
  const onAlarmRef = useRef(onAlarm);

  useEffect(() => {
    userIdRef.current = userId;
  }, [userId]);

  useEffect(() => {
    bsdIdsRef.current = bsdIds;
  }, [bsdIds]);

  useEffect(() => {
    onMessageRef.current = onMessage;
  }, [onMessage]);

  useEffect(() => {
    onAlarmRef.current = onAlarm;
  }, [onAlarm]);

  useEffect(() => {
    if (!userId) return;

    const client = createControlSocket(userId);
    clientRef.current = client;

    const subscribe = () => {
      resetSubscriptions(
        client,
        {
          userId: userIdRef.current,
          bsdIds: bsdIdsRef.current,
          subscribeBsdAlarm: true,
        },
        onMessageRef.current,
        onAlarmRef.current
      );
    };

    client.onConnect = subscribe;

    if (client.connected) {
      subscribe();
    }

    return () => {
      clientRef.current?.deactivate?.();
      clientRef.current?.disconnect?.();
      clientRef.current = null;
    };
  }, [userId]);

  useEffect(() => {
    const client = clientRef.current;
    if (!client?.connected) return;

    resetSubscriptions(
      client,
      {
        userId: userIdRef.current,
        bsdIds: bsdIdsRef.current,
        subscribeBsdAlarm: true,
      },
      onMessageRef.current,
      onAlarmRef.current
    );
  }, [bsdIds]);

  return clientRef;
}
